<ng-container [ngSwitch]="bannerKey">
    <app-buy-policy-banner *ngSwitchCase="BannerKey.BUY_POLICY"></app-buy-policy-banner>
    <app-accidents-happen-banner *ngSwitchCase="BannerKey.ACCIDENTS_HAPPEN"></app-accidents-happen-banner>
    <app-driver-sos-details-banner *ngSwitchCase="BannerKey.DRIVER_SOS_DETAILS"></app-driver-sos-details-banner>
</ng-container>
